module.exports = __webpack_public_path__ + "img/online-store.5d84a654.jpg";